import {
  STORAGE_LOCALE,
  STORAGE_USER_COUNTRY_CODE,
} from 'constants/app-constants';
import { getToken } from 'grab-login/lib/helper';
import { getEnvVar } from './env-helper';
import { isEmpty } from '../common/utils/data-utils';
import { getPaxAccessToken } from './grab-id-auth-helper';
import { isAuthHintCookie } from './session-helper';

export const buildAjaxCredentials = (isPax = false) =>
  !isPax && isAuthHintCookie() ? true : false;

export const buildHeadersV2 = ({
  isPax,
  companyID,
  authHeader = undefined,
  includeInternalHeaders = true,
  includeMTSHeader = true,
}) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (includeInternalHeaders) {
    const internalHeaders = {
      'X-Company-ID': companyID,
      'X-Grab-Web-App-Version': getEnvVar('APP_VERSION'),
      'Accept-Language': window.localStorage.getItem(STORAGE_LOCALE),
      'X-Country-Code': window.localStorage.getItem(STORAGE_USER_COUNTRY_CODE),
    };
    Object.entries(internalHeaders).forEach(([key, value]) => {
      if (!isEmpty(value)) {
        headers[key] = value;
      }
    });
  }

  // if auth method is cookie, adding Authorization key (even if value null)  will break api-gw auth
  if (isAuthHintCookie()) {
    return headers;
  }

  if (authHeader && authHeader.key && authHeader.value) {
    headers[authHeader.key] = authHeader.value;
  } else if (isPax) {
    headers.Authorization = `Bearer ${getPaxAccessToken()}`;
  } else {
    const token = getToken();
    headers.Authorization = token;
    if (includeMTSHeader) {
      headers['X-mts-ssid'] = token;
    }
  }

  return headers;
};

export default {};
